import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { TableChiTietTraLai } from "./TableChiTietTraLai";
import { ThongTinHopDong } from "./ThongTinHopDong";
import NhanVayApi from "../../../../service/nhanVayApi";
import { pushNotification } from "utils/notifications";
import { useSelector, useDispatch } from "react-redux";
import { getListNhanVay, updateDataSearch } from "../../../../actions/NhanVay/";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import useHinhThucThanhToan from "utils/useHinhThucThanhToan";

export const TraNhanVay = (props) => {
  const dispatch = useDispatch();

  const initTra = {
    NhanVayId: props.NhanVayId,
    NguoiNhan: props.dataNguoiNhan,
    NgayThanhToan: currentDate(),
    TienTra: 0,
    PhiKhac: 0,
    PhiKho: 0,
    GhiChu: "",
  };
  const [dataTra, setDataTra] = useState(initTra);

  const initThongTinTra = {
    NhanVayId: 0,
    TenChuNo: "",
    NgaySinh: null,
    DiaChi: "",
    MaHopDong: "",
    NgayVay: "",
    NgayTra: "",
    SoTienVay: 0,
    TongTienLai: 0,
    TongTienPhaiTra: 0,
    SoTienDaTra: 0,
    SoTienConPhaiTra: 0,
    SoNgayTraLai: 0,
    KieuTraLai: "",
  };
  const [dataThongTinTra, setDataThongTinTra] = useState(initThongTinTra);

  const initHopDong = {
    Address: "",
    AddressCmt: "",
    AnhKhachHang: "",
    BeforeAfter: 0,
    Birthday: "01/01/1900 00:00:00",
    Cmt: "",
    CountTypePaid: 0,
    CustomerId: 0,
    DateCmt: "01/01/1900 00:00:00",
    DsTaiSanNhanVay: [],
    FileDinhKems: null,
    GhiChu: "",
    GiayToTheChap: "",
    KieuLaiSuat: 0,
    LaiNgay: 0,
    MaNhanVay: "",
    NgayTao: "01/01/1900 00:00:00",
    NgayTra: "01/01/1900 00:00:00",
    NgayVay: "01/01/1900 00:00:00",
    NguoiTao: "",
    NhanVayID: 0,
    Phone: "",
    SoLanTra: 0,
    Sotienvay: 0,
    TenKhachHang: "",
    TypePaid: 0,
  };
  const [hopdong, setDataHopDong] = useState(initHopDong);

  useEffect(() => {
    LayThongTinTra();
    ChiTietHopDong();
  }, []);

  const ChiTietHopDong = () => {
    NhanVayApi.getChiTietHopDong1(props.NhanVayId).then((response) => {
      setDataHopDong({
        Address: response.data.Address,
        AddressCmt: response.data.AddressCmt,
        AnhKhachHang: response.data.AnhKhachHang,
        BeforeAfter: response.data.BeforeAfter,
        Birthday: response.data.Birthday,
        Cmt: response.data.Cmt,
        CountTypePaid: response.data.CountTypePaid,
        CustomerId: response.data.CustomerId,
        DateCmt: response.data.DateCmt,
        DsTaiSanNhanVay: response.data.DsTaiSanNhanVay,
        FileDinhKems: response.data.FileDinhKems,
        GhiChu: response.data.GhiChu,
        GiayToTheChap: response.data.GiayToTheChap,
        KieuLaiSuat: response.data.KieuLaiSuat,
        LaiNgay: response.data.LaiNgay,
        MaNhanVay: response.data.MaNhanVay,
        NgayTao: response.data.NgayTao,
        NgayTra: response.data.NgayTra,
        NgayVay: response.data.NgayVay,
        NguoiTao: response.data.NguoiTao,
        NhanVayID: response.data.NhanVayID,
        Phone: response.data.Phone,
        SoLanTra: response.data.SoLanTra,
        Sotienvay: response.data.Sotienvay,
        TenKhachHang: response.data.TenKhachHang,
        TypePaid: response.data.TypePaid,
      });
    });
  };

  const LayThongTinTra = () => {
    NhanVayApi.getChiTietHopDong(props.NhanVayId, currentDate()).then(
      (response) => {
        //Lấy được thông tin tất toán hợp đồng
        setDataThongTinTra({
          ...dataThongTinTra,
          NhanVayId: props.NhanVayId,
          TenChuNo: response.data.TenChuNo,
          NgaySinh: response.data.NgaySinh,
          DiaChi: response.data.DiaChi,
          MaHopDong: response.data.MaHopDong,
          NgayVay: response.data.NgayVay,
          NgayTra: response.data.NgayTra,
          SoTienVay: response.data.SoTienVay,
          TongTienLai: response.data.TongTienLai,
          TongTienPhaiTra: response.data.TongTienPhaiTra,
          SoTienDaTra: response.data.SoTienDaTra,
          SoTienConPhaiTra: response.data.SoTienConPhaiTra,
          SoNgayTraLai: response.data.SoNgayTraLai,
          KieuTraLai: response.data.KieuTraLai,
        });

        setDataTra({
          ...dataTra,
          NhanVayId: props.NhanVayId,
          NguoiNhan: props.NguoiNhan,
          NgayThanhToan: currentDate(),
          TienTra: response.data.SoTienConPhaiTra,
          PhiKhac: dataTra.PhiKhac,
          PhiKho: dataTra.PhiKho,
          GhiChu: dataTra.GhiChu,
        });
      }
    );
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataTra({
      ...dataTra,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors({
        ...errors,
        nguoiNhan: "Tên người nhận không được để trống",
      });
      NguoiNhan.current.focus();
    } else {
      setErrors({
        ...errors,
        nguoiNhan: "",
      });
    }
  };
  const onChangeNumber = (field) => (evt) => {
    setDataTra({
      ...dataTra,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "" || evt.target.value === 0) {
      setErrors2({
        ...errors2,
        TienTra: "Nhập số tiền trả",
      });
      TienTra.current.focus();
    } else {
      setErrors2({
        ...errors2,
        TienTra: "",
      });
    }
  };

  const updateNgayTraValue = (field) => (evt) => {
    setDataTra({
      ...dataTra,
      [field]: formatDayMonth(evt),
    });
    dataTra.NgayThanhToan = formatDayMonth(evt);
    NhanVayApi.getChiTietHopDong(props.NhanVayId, dataTra.NgayThanhToan).then(
      (response) => {
        //Lấy được thông tin tất toán hợp đồng
        setDataTra({
          ...dataTra,
          TienTra: response.data.SoTienConPhaiTra,
        });
        setDataThongTinTra({
          ...dataThongTinTra,
          SoTienConPhaiTra: response.data.SoTienConPhaiTra,
          SoNgayTraLai: response.data.SoNgayTraLai,
          
        });
      }
    );
    if (evt === "null") {
      setErrors1({
        ...errors1,
        ngayThanhToan: "Nhập ngày thanh toán",
      });
    } else {
      setErrors1({
        ...errors1,
        ngayThanhToan: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setDataTra({
      ...dataTra,
      [field]: formatDayMonth(evt),
    });
    if (evt === "null") {
      setErrors1({
        ...errors1,
        ngayThanhToan: "Nhập ngày thanh toán",
      });
    } else {
      setErrors1({
        ...errors1,
        ngayThanhToan: "",
      });
    }
  };

  const onChangeDate1 = (field) => (evt) => {
    setDataTra({
      ...dataTra,
      [field]: evt,
    });
  };

  //Thông báo
  const initErrors = {
    nguoiNhan: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    ngayThanhToan: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = {
    TienTra: "",
  };
  const [errors2, setErrors2] = useState(initErrors2);

  const dataSearch = useSelector((state) => state.dataSearchNhanVay);
  const NguoiNhan = React.createRef();
  const TienTra = React.createRef();
  //Ref chặn bấm Xác nhận 2 lần liên tiếp trước khi state kịp render lại
  const isSavingRef = React.useRef(false);
  const [isSaving, setIsSaving] = useState(false);
  const batHinhThucThanhToan = useHinhThucThanhToan();
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState("0");
  const onSubmitTra = () => {
    if (isSavingRef.current) return;
    // Validate

    if (dataTra.NguoiNhan === "") {
      setErrors({
        ...errors,
        nguoiNhan: "Tên người nhận không được để trống",
      });
      NguoiNhan.current.focus();
      return;
    } else if (
      dataTra.NgayThanhToan === "null" ||
      dataTra.NgayThanhToan === null ||
      dataTra.NgayThanhToan === ""
    ) {
      setErrors1({
        ...errors1,
        ngayThanhToan: "Nhập ngày thanh toán",
      });

      return;
    } else if (dataTra.TienTra === "" || dataTra.TienTra === 0) {
      setErrors2({
        ...errors2,
        TienTra: "Nhập số tiền trả",
      });
      TienTra.current.focus();

      return;
    } else {
      isSavingRef.current = true;
      setIsSaving(true);
      NhanVayApi.traNhanVay(
        dataTra.NhanVayId,
        dataTra.NguoiNhan,
        dataTra.NgayThanhToan,
        dataTra.TienTra,
        dataTra.PhiKhac,
        dataTra.PhiKho,
        dataTra.GhiChu,
        batHinhThucThanhToan ? parseInt(hinhThucThanhToan, 10) : null
      )
        .then((response) => {
          //Mất mạng/timeout: apisauce trả data null, server có thể đã lưu nên nhắc kiểm tra trước khi làm lại
          if (!response.data) {
            pushNotification(
              "Không nhận được phản hồi từ máy chủ, vui lòng kiểm tra lại trạng thái hợp đồng trước khi thử lại!",
              "error",
              "TOP_CENTER",
              5000
            );
            return;
          }
          if (response.data.Error === 1) {
            pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
            return;
          } else {
            // showAlert();
            pushNotification(
              "Trả nhận vay hợp đồng thành công",
              "success",
              "TOP_CENTER",
              1000
            );
            props.onHide();
            dispatch(getListNhanVay(dataSearch));
          }
        })
        .finally(() => {
          isSavingRef.current = false;
          setIsSaving(false);
        });
      // .then((response) => hideModalTra());
    }
  };
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="fas fa-hand-holding-usd"></i>
          </span>
          Trả nhận vay
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div className="row">
          <div className="col-md-12 col-lg-4 pad-right0">
            <div className="">
           <ul className="nav nav-tabs bg-tab"  style={{height:50}}>
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="base-tab1"
                    data-toggle="tab"
                    aria-controls="tab1"
                    href="#tab-thongtintt"
                    aria-expanded="true"
                    style={{ height: 35 }}
                  >
                    <h4>Nội dung trả</h4>
                  </a>
                </li>
              </ul>
              <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                <div
                  className="tab-pane active"
                  id="tab-thongtintt"
                  aria-expanded="true"
                  aria-labelledby="base-tab1"
                >
                  <div className="detail-tattoan">
                    <div className="row">
                      <div className="col-md-6">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Người nhận"
                          inputProps={{
                            name: "dataTra.NguoiNhan",
                            ref: NguoiNhan,
                            onChange: updateTextValue("NguoiNhan"),
                            value: dataTra.NguoiNhan,
                          }}
                        ></TextInputOnRow>
                        {errors.nguoiNhan && (
                          <span className="canh-bao-red">
                            {errors.nguoiNhan}
                          </span>
                        )}
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label for="projectinput1">Ngày thanh toán</label>
                          <DateTimePicker
                            value={convertDate(dataTra.NgayThanhToan)}
                            onChange={updateNgayTraValue("NgayThanhToan")}
                            name="NgayThanhToan"
                          ></DateTimePicker>
                        </div>
                        {errors1.ngayThanhToan && (
                          <span className="canh-bao-red">
                            {errors1.ngayThanhToan}
                          </span>
                        )}
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Tiền trả nhận vay"
                          inputProps={{
                            name: "dataTraBotGoc.TienTra",
                            ref: TienTra,
                            onChange: onChangeNumber("TienTra"),
                            value: formatNumber(dataTra.TienTra),
                            disabled: !props.quyenSuaTienTatToan,
                          }}
                        ></TextInputOnRow>
                        {errors2.TienTra && (
                          <span className="canh-bao-red">
                            {errors2.TienTra}
                          </span>
                        )}
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Phí khác"
                          inputProps={{
                            name: "dataTra.PhiKhac",
                            // ref: register,
                            onChange: onChangeNumber("PhiKhac"),
                            value: formatNumber(dataTra.PhiKhac),
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Tổng tiền trả"
                          inputProps={{
                            value: formatNumber(
                              dataTra.TienTra + dataTra.PhiKhac
                            ),
                            disabled: true,
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <label for="projectinput8">Ghi chú</label>
                          <textarea
                            rows="3"
                            className="form-control input-sm"
                            name="GhiChu"
                            placeholder="Ghi chú"
                            value={dataTra.GhiChu}
                            onChange={updateTextValue("GhiChu")}
                          ></textarea>
                        </div>
                      </div>

                      {batHinhThucThanhToan && (
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Hình thức thanh toán</label>
                            <select
                              className="form-control input-sm"
                              value={hinhThucThanhToan}
                              onChange={(e) => setHinhThucThanhToan(e.target.value)}
                            >
                              <option value="0">Tiền mặt</option>
                              <option value="1">Chuyển khoản</option>
                            </select>
                          </div>
                        </div>
                      )}

                      <div className="col-md-12">
                        <div className="text-right">
                          <button
                            type="button"
                            className="btn btn-new-main btn-checknew"
                            onClick={onSubmitTra}
                            disabled={isSaving}
                          >
                            {isSaving ? (
                              <>
                                <span className="spinner-border spinner-border-sm"></span>
                                &nbsp; Đang xử lý...
                              </>
                            ) : (
                              <>
                                <span className="btn-icon-left">
                                  <i className="mdi mdi-check-underline-circle"></i>
                                </span>{" "}
                                Xác nhận
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-lg-8">
            <div className="tattoan-formright">
              <ul className="nav nav-tabs bg-tab"  style={{height:50}}>
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="base-tab1"
                    data-toggle="tab"
                    aria-controls="tab1"
                    href="#tab-detailtt"
                    aria-expanded="true"
                    style={{ height: 35 }}
                  >
                    <h4>Chi tiết trả</h4>
                  </a>
                </li>
                <li className="nav-item disk-mobile">
                  <a
                    className="nav-link"
                    id="base-tab1"
                    data-toggle="tab"
                    aria-controls="tab1"
                    href="#tab-noidung"
                    aria-expanded="true"
                    style={{ height: 35 }}
                  >
                    <h4>Thông tin hợp đồng</h4>
                  </a>
                </li>
              </ul>
              <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                <div
                  className="tab-pane active"
                  id="tab-detailtt"
                  aria-expanded="true"
                  aria-labelledby="base-tab1"
                >
                  <TableChiTietTraLai nhanvayId={props.NhanVayId} />
                </div>
                <div
                  className="tab-pane"
                  id="tab-noidung"
                  aria-expanded="true"
                  aria-labelledby="base-tab1"
                >
                  <ThongTinHopDong
                    dataThongTinTra={dataThongTinTra}
                    hopdong={hopdong}
                    item={props.item}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
